export default "https://static.ingenie.fr/modules/assets/seats/images/ticket_icon.a94ac9b4aec17ef028835bc6d6bb64d3.png";